import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'tm-toggle',
  templateUrl: './tm-toggle.component.html',
  styleUrls: ['./tm-toggle.component.scss']
})
export class TmToggleComponent implements OnInit, OnChanges {
  @Input() form_group;
  @Input() label;
  @Input() mandatory;
  @Input() form_control;
  @Input() ng_model;
  @Input() data;
  @Input() disabled;
  @Input() active_label = "USER.active";
  @Input() inactive_label = "USER.inactive";
  @Input() extra_class;
  @Input() label_inline = 0;
  @Input() options = [{
    id: 1,
    title: 'active'
  }, {
    id: 0,
    title: 'inactive'
  }]
  @Output() valueChanges = new EventEmitter();
  checkbox
  random_id = 'tm-toggle' + Math.floor((Math.random() * 10000) + 1) + Date.now();
  constructor() { }

  ngOnInit(): void {
  }
  ngOnChanges(ev) {
    if (ev && ev.options) {
      this.options = ev.options.currentValue;
    }

    if (ev && ev.data) {
      this.data = ev.data.currentValue;
      this.options.forEach(option => {
        if (option['id'] == this.data) {
          if (option['title'] == 'active') {
            this.checkbox = 1;
          }
          else {
            this.checkbox = 0;
          }
        }
      })
    }

  }
  toggleButton(ev?) {
    try {
      if (ev) {
        if (this.form_group && this.form_group.controls[this.form_control]) {
          this.options.forEach(o => {
            if (o['title'] == 'active') {
              this.form_group.controls[this.form_control].patchValue(o.id)
              this.valueChanges.emit(o.id)
            }
          })
        }
        else {
          this.options.forEach(o => {
            if (o['title'] == 'active') {
              this.valueChanges.emit(o.id)
            }
          })
        }
      }
      else {
        if (this.form_group && this.form_group.controls[this.form_control]) {
          this.options.forEach(o => {
            if (o['title'] == 'inactive') {
              this.form_group.controls[this.form_control].patchValue(o.id);
              this.valueChanges.emit(o.id)
            }
          })
        }
        else {
          this.options.forEach(o => {
            if (o['title'] == 'inactive') {
              this.valueChanges.emit(o.id)
            }
          })
        }
      }
    }
    catch (err) {
      console.log(err)
    }
  }

}
